import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function AdminLogin() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/admin/login', form);
      localStorage.setItem('adminToken', data.token);
      localStorage.setItem('adminInfo', JSON.stringify(data.admin));
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Left Panel */}
        <div style={styles.leftPanel}>
        <div style={styles.leftContent}>
          {/* Cloud + Grid Icon */}
          <div style={styles.iconWrap}>
            <svg width="90" height="80" viewBox="0 0 90 80" fill="none">
              <ellipse cx="52" cy="32" rx="28" ry="20" fill="#2563eb" opacity="0.15"/>
              <path d="M18 38 Q14 22 28 20 Q30 10 44 12 Q52 4 62 12 Q76 12 76 26 Q84 28 82 40 Q80 50 68 48 H28 Q16 48 18 38Z"
                fill="#2563eb"/>
              <rect x="28" y="50" width="34" height="22" rx="4" fill="#dc2626"/>
              <rect x="31" y="54" width="8" height="6" rx="1" fill="#fff"/>
              <rect x="41" y="54" width="8" height="6" rx="1" fill="#fff"/>
              <rect x="51" y="54" width="8" height="6" rx="1" fill="#fff"/>
              <rect x="31" y="62" width="8" height="6" rx="1" fill="#fff"/>
              <rect x="41" y="62" width="8" height="6" rx="1" fill="#fff"/>
              <rect x="51" y="62" width="8" height="6" rx="1" fill="#fff"/>
            </svg>
          </div>
          <h1 style={styles.welcomeText}>Hi there,<br />welcome in!</h1>
        </div>
        {/* City skyline */}
        <div style={styles.skyline}>
          {[
            { h: 110, w: 28, l: 0 },
            { h: 150, w: 36, l: 32 },
            { h: 90,  w: 24, l: 72 },
            { h: 180, w: 40, l: 100 },
            { h: 120, w: 30, l: 144 },
            { h: 200, w: 44, l: 178 },
            { h: 130, w: 32, l: 226 },
            { h: 160, w: 38, l: 262 },
            { h: 100, w: 26, l: 304 },
          ].map((b, i) => (
            <div key={i} style={{
              position: 'absolute', bottom: 0, left: b.l,
              width: b.w, height: b.h,
              background: `rgba(147,197,253,${0.25 + (i % 3) * 0.15})`,
              borderRadius: '3px 3px 0 0',
            }} />
          ))}
        </div>
      </div>

        {/* Right Panel */}
        <div style={styles.rightPanel}>
        <div style={styles.formWrap}>
          <h2 style={styles.title}>Shield Secure Admin</h2>
          <h3 style={styles.heading}>Let's get you logged in</h3>
          <p style={styles.subtext}>
            Enter your details below to securely access your account and enjoy a seamless experience.
          </p>

          <form onSubmit={handleSubmit}>
            <div style={styles.field}>
              <label style={styles.label}>Email Address</label>
              <div style={styles.inputWrap}>
                <span style={styles.inputIcon}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
                    <rect x="2" y="4" width="20" height="16" rx="2"/>
                    <path d="M2 7l10 7 10-7"/>
                  </svg>
                </span>
                <input
                  style={styles.input}
                  type="email"
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                  autoFocus
                />
              </div>
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Password</label>
              <div style={styles.inputWrap}>
                <span style={styles.inputIcon}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                </span>
                <input
                  style={styles.input}
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required
                />
                <span style={styles.eyeIcon} onClick={() => setShowPassword(s => !s)}>
                  {showPassword ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  )}
                </span>
              </div>
            </div>

            {error && <p style={styles.error}>{error}</p>}

            <button style={{ ...styles.button, opacity: loading ? 0.75 : 1 }} type="submit" disabled={loading}>
              {loading ? 'Logging in…' : 'Log In'}
            </button>
          </form>
        </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#f3f4f6', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  card: {
    display: 'flex', width: '800px', maxWidth: '96vw',
    borderRadius: 16, overflow: 'hidden',
    boxShadow: '0 8px 40px rgba(0,0,0,0.13)',
  },
  /* ── Left ── */
  leftPanel: {
    width: '260px', flexShrink: 0,
    background: 'linear-gradient(160deg, #dbeafe 0%, #eff6ff 60%, #bfdbfe 100%)',
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
    position: 'relative', overflow: 'hidden',
  },
  leftContent: { padding: '40px 28px 0', zIndex: 1 },
  iconWrap: { marginBottom: 20 },
  welcomeText: { fontSize: 28, fontWeight: 800, color: '#111827', lineHeight: 1.25, margin: 0 },
  skyline: { position: 'relative', height: 200, width: '100%' },
  /* ── Right ── */
  rightPanel: {
    flex: 1, background: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '40px 36px',
  },
  formWrap: { width: '100%' },
  title: { fontSize: 13, fontWeight: 600, color: '#2563eb', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 },
  heading: { fontSize: 30, fontWeight: 800, color: '#111827', margin: '0 0 10px' },
  subtext: { fontSize: 14, color: '#6b7280', marginBottom: 32, lineHeight: 1.6 },
  field: { marginBottom: 20 },
  label: { display: 'block', fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 8 },
  inputWrap: {
    display: 'flex', alignItems: 'center',
    border: '1.5px solid #e5e7eb', borderRadius: 8,
    background: '#fff', transition: 'border-color 0.2s',
  },
  inputIcon: { padding: '0 12px', display: 'flex', alignItems: 'center', flexShrink: 0 },
  eyeIcon: { padding: '0 12px', display: 'flex', alignItems: 'center', cursor: 'pointer', flexShrink: 0 },
  input: {
    flex: 1, padding: '14px 0', border: 'none', outline: 'none',
    fontSize: 14, color: '#111827', background: 'transparent',
  },
  error: { color: '#dc2626', fontSize: 13, marginBottom: 14 },
  button: {
    width: '100%', padding: '15px', background: '#2563eb', color: '#fff',
    border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600,
    cursor: 'pointer', marginTop: 8, letterSpacing: 0.3,
  },
};
